import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductGridItemComponent, ProductListItemContext, ProductListItemContextSource } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-product-grid-item',
  templateUrl: './custom-product-grid-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
  standalone: false
})
export class CustomProductGridItemComponent extends ProductGridItemComponent {

}
